// @flow
import styled, { css } from 'styled-components';
import DefaultTheme from '../index';
import { neutral700 } from '../../../colors';
/*::
import type { TooltipThemeType } from '../index';
*/

var ShipaMallTheme
/* :TooltipThemeType */
= Object.assign({}, DefaultTheme, {
  ArrowTopCss: css(["", " border-bottom:1rem solid ", ";"], DefaultTheme.ArrowTopCss, neutral700()),
  ArrowBottomCss: css(["", " border-top:1rem solid ", ";"], DefaultTheme.ArrowBottomCss, neutral700()),
  ArrowLeftCss: css(["", " border-right:1rem solid ", ";"], DefaultTheme.ArrowLeftCss, neutral700()),
  ArrowRightCss: css(["", " border-left:1rem solid ", ";"], DefaultTheme.ArrowRightCss, neutral700()),
  TransparentOffset: styled(DefaultTheme.TransparentOffset).withConfig({
    displayName: "shipamall__TransparentOffset",
    componentId: "tsml0h-0"
  })(["box-sizing:border-box;"]),
  Main: styled(DefaultTheme.Main).withConfig({
    displayName: "shipamall__Main",
    componentId: "tsml0h-1"
  })(["background:", ";padding:0.4rem 0.8rem;"], neutral700())
});
export default ShipaMallTheme;